import type { ErrorLocaleKey } from './errorLocaleKeys';

export enum FileValidationErrorCodes {
    MAX_SIZE = 'MAX_SIZE',
    INVALID_TYPE = 'INVALID_TYPE',
    NO_FILE = 'NO_FILE',
    NO_FILENAME = 'NO_FILENAME',
    INVALID_FILENAME = 'INVALID_FILENAME',
    INVALID_EXTENSION = 'INVALID_EXTENSION',
}

interface Props {
    code: FileValidationErrorCodes;
    message: string;
    explanation?: string;
    errorLocaleKey?: ErrorLocaleKey;
    context?: Record<string, unknown>;
    details?: {
        type: string;
        expected?: string;
        actual: string | number;
        max?: number;
    };
}

export default class FileValidationError extends Error {
    public static type = 'VALIDATION';
    private error: boolean;
    private code: FileValidationErrorCodes;
    private explanation: string | undefined;
    public errorLocaleKey: ErrorLocaleKey | undefined;
    public context: Record<string, unknown> | undefined;
    private details:
        | {
              type: string;
              expected?: string;
              actual: string | number;
              max?: number;
          }
        | undefined;

    constructor(props: Props) {
        super(props.message);

        this.error = true;
        this.code = props.code;
        this.message = props.message;
        this.explanation = props.explanation;
        this.errorLocaleKey = props.errorLocaleKey;
        this.context = props.context;
        this.details = props.details;
    }
}
